import {
    Component,
    ElementRef,
    EventEmitter,
    forwardRef,
    HostBinding,
    Input, OnChanges,
    Output, SimpleChanges,
    ViewChild
} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {SelectOptionModel} from '../../../models/select-option-model';


@Component({
    selector: 'app-input-flat-select',
    templateUrl: './input-flat-select.component.html',
    styleUrl: './input-flat-select.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputFlatSelectComponent),
            multi: true,
        },
    ],
})
export class InputFlatSelectComponent implements ControlValueAccessor, OnChanges {

    @ViewChild('container') borderElement!: ElementRef;
    @Input() public labelLeft: string;
    @Input() public labelRight: string;

    @Input() public placeholderHtmlLeft: string;
    @Input() public placeholderHtmlRight: string;
    @Input() public required: boolean | string;
    @Input() public name: string;
    @Input() public options: SelectOptionModel<any>[] = [];

    @Output() public blur: EventEmitter<any> = new EventEmitter<any>();
    @Output() public focus: EventEmitter<any> = new EventEmitter<any>();

    @Input() compareByFn: (item1: any, item2: any) => boolean = this.compareByDefaultFn;

    @HostBinding('class.active') isActive: boolean;

    selectedValues: any[] = [];
    notSelectedValues: any[] = [];

    public propagateChange: (_: any) => void = (_: any) => {
    };
    public onTouched: () => void = () => {
    };


    writeValue(value: any): void {
        this.selectedValues = value;

        this.calculateNotSelectedValues();


    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['options']) {
            this.calculateNotSelectedValues();
        }
    }

    calculateNotSelectedValues() {
        this.notSelectedValues = this.options?.filter(
            (option) => !this.selectedValues?.some((value) => this.compareByFn(option.value, value))
        ).map((op) => op.value);
    }

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    compareByDefaultFn(item1: any, item2: any): boolean {
        return item1 === item2;
    }


    onModelChange() {

    }

    onLeftModelChange() {
        this.notSelectedValues = this.options?.filter(
            (option) => !this.selectedValues?.some((value) => this.compareByFn(option.value, value))
        ).map((op) => op.value);

        this.propagateChange(this.selectedValues);


    }

    onRightModelChange() {

        this.selectedValues = this.options.filter(
            (option) => !this.notSelectedValues?.some((value) => this.compareByFn(option.value, value))
        ).map((op) => op.value);
        this.propagateChange(this.selectedValues);
    }

    onFocus(): void {
        if (!this.isActive) {
            this.isActive = true; // Activate focus state only once
            this.focus.emit(); // Emit focus event
        }
    }

    onBlur(): void {
        setTimeout(() => {
            const activeElement = document.activeElement;


            if (this.borderElement && !this.borderElement.nativeElement.contains(activeElement) && this.borderElement.nativeElement !== activeElement) {
                this.isActive = false; // Deactivate focus state
                this.onTouched(); // Mark as touched for forms
                this.blur.emit(); // Emit blur event
            }
        }, 0);
    }

    get isRequired(): boolean {
        return this.required === '' || this.required === true;
    }

    getLabelLeft() {
        return this.labelLeft + (this.isRequired ? '*' : '');
    }

    getLabelRight() {
        return this.labelRight + (this.isRequired ? '*' : '');
    }


}
